import React from "react";

const RotatingLogo = ({ size = 60 }) => {
    return (
        <div
            className="relative group"
            style={{ width: size, height: size }}
        >

            {/* Rotating SVG */}
            <img
                src="/images/nath_nagri_bareilly_Logocircle.svg"
                alt="Rotating Mandala"
                className="absolute inset-0 w-full h-full animate-spin-slow"
            />

            {/* Center Logo */}
            <div className="absolute inset-0 flex items-center justify-center">
                <img
                    src="/images/nathnagri-bareilly-logo.png"
                    alt="Logo"
                    className="w-[80%] h-[80%] object-contain"
                />
            </div>

            {/* Animation */}
            <style>
                {`
                  @keyframes spin-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                  }
                  
                  .animate-spin-slow {
                    animation: spin-slow 20s linear infinite;
                  }
                  
                  .group:hover .animate-spin-slow {
                    animation-play-state: paused;
                  }
                `}
            </style>

        </div>
    );
};

export default RotatingLogo;